<template>
  <div class="Box">
    <div class="shadow"></div>
    <div class="content">
      <div class="msg">
        <span v-if="top">{{top}}</span>
        <span>{{typeof title == 'string' ? title : title.msg}}</span>
        <span v-if="title=='请下载安装雷电圈APP'">到APP内参加活动</span>
      </div>
      <button class="btn0 mt" @click.stop="clickCancle">{{title=='请下载安装雷电圈APP' ? '官网下载' : '确定'}}</button>
      <div class="cancel" @click="()=>{this.$emit('cancle')}" v-if="title=='请下载安装雷电圈APP'"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: [Object, String],
      default: ""
    },

    top: {
      type: String,
      default: ""
    }
  },
  methods: {
    clickCancle() {
      if (typeof this.title == "object") {
        this.$emit("cancle", this.title);
      }
      if (this.title == "请下载安装雷电圈APP") {
        window.location.href = "http://ldq.ldmnq.com/download";
      } else {
        this.$emit("cancle");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.Box {
  width: 100%;
  height: 100%;
  position:fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.content {
  position: absolute;
  z-index: 9999;
  border-radius: 10px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 660px;
  height: 300px;
  text-align: center;
  font-size: 24px;
  background: #fff;
  padding: 35px 30px;
  .msg {
    width: 100%;
    height: 150px;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    span {
      margin-bottom: 30px;
    }
  }
  .btn0 {
    width: 100%;
    height: 70px;
    background: #d753f0;
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    color: #fff;
    border-radius: 10px;
  }
}
.cancel {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  height: 48px;
  width: 48px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
</style>
